import { useRouter } from "next/router";
import localized from "../locale/locales";
import { getCookiePreferences } from "../helpers/cookies";
import Button from "../components/Button";
import Container from "../components/Container";
import MainLayout from "../components/layouts/MainLayout";
import Title from "../components/Title";

import OwnerBlock from "../components/OwnerBlock";
import FadingLogo from "../components/FadingLogo";
import AboutHighlights from "../components/AboutHighlights";
import NewPlaces from "../components/NewPlaces";
import HeroVideo from "../components/HeroVideo";
import Typo from "../components/Typo";
import iconHeart from "../public/img/icons/heart.png";
import iconBurn from "../public/img/icons/burn.png";
import iconAi from "../public/img/icons/ai.png";
import iconSoul from "../public/img/icons/soul.png";
import iconTechnology from "../public/img/icons/technology.png";
import iconCommunity from "../public/img/icons/community.png";
import SectionFeatures from "../components/sections/SectionFeatures";
import PopupVideo from "../components/popups/PopupVideo";
import { useState } from "react";
import SectionManifest from "../components/sections/SectionManifest";

const icons = [
  iconHeart,
  iconCommunity,
  iconAi,
  iconSoul,
  iconBurn,
  iconTechnology,
];

export default function AboutUs({ hasCookiePreferences, cookiePreferences }) {
  const [activeVideo, setActiveVideo] = useState(null);
  const [hiddenNav, setHiddenNav] = useState(false);

  const { locale } = useRouter();
  const { aboutUs: lang, og } = localized[locale];

  return (
    <MainLayout
      hasCookiePreferences={hasCookiePreferences}
      cookiePreferences={cookiePreferences}
      footerTheme="dark"
      hiddenNav={hiddenNav}
      title={lang.og?.title || lang.title}
      description={lang.og.description}
    >
      <PopupVideo
        active={!!activeVideo}
        onClose={() => {
          setActiveVideo(null);
          setHiddenNav(false);
        }}
        activeVideo={activeVideo}
      />

      <HeroVideo
        size="medium"
        mobileVideo="/videos/hero/about_mobile.mp4"
        tabletVideo="/videos/hero/about_tablet.mp4"
        desktopVideo="/videos/hero/about_desktop.mp4"
        align="bottom"
      >
        <div className={`flex flex-col gap-4 max-w-[430px] pb-20`}>
          <header>
            <Title Elem="h1">{lang.header.title}</Title>
          </header>
          <Typo>
            <span className="md:hidden">{lang.header.body.mobile}</span>
            <span className="hidden md:inline">{lang.header.body.desktop}</span>
          </Typo>
        </div>
      </HeroVideo>

      <OwnerBlock />

      <div className="relative overflow-hidden -mb-20 hidden md:block pt-20 pb-10">
        <FadingLogo />
      </div>

      <Container className="-mb-48 relative z-20" fullMobile={true}>
        <AboutHighlights />
      </Container>

      <div className="bg-black text-white relative z-10">
        <NewPlaces className="pt-72" />
      </div>

      <SectionManifest
        setActiveVideo={setActiveVideo}
        openPopup={() => {
          setHiddenNav(true);
        }}
      />

      <div className="bg-black text-white pt-48 md:pt-96 pb-32">
        <Container className="pt-10 mb-16 text-center">
          <header>
            <h2 className="text-3xl font-bold mb-2">{lang.values.title}</h2>
            <p className="text-base">{lang.values.subtitle}</p>
          </header>
        </Container>
        <SectionFeatures items={lang.values.items} icons={icons} />
      </div>

      <Container className="py-24 md:py-32">
        <section className="flex flex-col items-center gap-12">
          <p
            className="max-w-[30ch] mx-auto text-center text-2xl md:text-3xl"
            dangerouslySetInnerHTML={{ __html: lang.banner.body }}
          />
          <div>
            <Button label={lang.banner.cta} href="/#free-trial" />
          </div>
        </section>
      </Container>
    </MainLayout>
  );
}

export async function getServerSideProps({ req, res }) {
  const cookiePreferences = getCookiePreferences(req);

  return {
    props: {
      ...cookiePreferences,
    },
  };
}
